/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForQualys extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForQualys");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForQualys.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForQualys>): ServiceAccountCredentialsForQualys {
        let obj = Object.assign(new ServiceAccountCredentialsForQualys(), model);
        ServiceAccountCredentialsForQualys.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForQualys>): ServiceAccountCredentialsForQualys {
        if (!model) return null;
        return ServiceAccountCredentialsForQualys.newInstance(<ServiceAccountCredentialsForQualys> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForQualys) {
        if (!obj) return;

        models.ServiceAccountCredentialsForQualys.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForQualys): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForQualys.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * API Gateway URL. This is a required field.
     */
    api_gateway_url: string;

    /**
     * API Server URL. This is a required field.
     */
    api_server_url: string;

    /**
     * Username. This is a required field.
     */
    username: string;

    /**
     * Password. This is a required field.
     */
    password: string;

    /**
     * Cloud Provider. This is a required field.
     */
    service_account_type: models.CloudServiceName;

    /**
     * ServiceAccount Id. This is a required field.
     */
    service_account: string;

}
